"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CannedAnswerTypeEnum = void 0;
var CannedAnswerTypeEnum;
(function (CannedAnswerTypeEnum) {
    CannedAnswerTypeEnum["Queue"] = "Q";
    CannedAnswerTypeEnum["Agent"] = "A";
})(CannedAnswerTypeEnum = exports.CannedAnswerTypeEnum || (exports.CannedAnswerTypeEnum = {}));
